import { mapGetters } from 'vuex'
export const Mixins = {
    computed: {
        ...mapGetters(['cid']),
    },
    data() {
        return {
            elder: []
        }
    },
    create() {
    },
    methods: {
    }
}